import React, { useEffect } from "react";
import WhiteCover from "../components/WhiteCover/WhiteCover";

import HiringSection from "../components/HiringSection/HiringSection";
import CompanyPoliciesList from "../components/CompanyPoliciesList/CompanyPoliciesList";

const CompanyPolicies = ({ startLoader }) => {
  useEffect(() => {
    startLoader();
    window.scrollTo({ top: 0, behavior: "smooth" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <WhiteCover>
        <div
          className="d-flex flex-dir-col career-section-1"
          style={{
            backgroundColor: "#F6F5F7",
            paddingTop: 24,
          }}
        >
          <span
            className="h1-sb text-align-center"
            style={{ textDecoration: "none", fontSize: 36, color: "#1A0B39" }}
          >
            Company Policies
          </span>
          <span
            className="h3-sb text-align-center"
            style={{
              color: "#1A0B39",
              marginTop: 16,
              fontWeight: 400,
              fontSize: 20,
              paddingBottom: 24,
            }}
          >
            Below are the company policy documents in PDF format. Please select
            any of the links provided to open the corresponding file in a new
            window.
          </span>
          <CompanyPoliciesList />
        </div>
      </WhiteCover>
      <WhiteCover></WhiteCover>
      <HiringSection />
    </div>
  );
};

export default CompanyPolicies;
